import { api } from "@/api";
import type { ProfileUpdatePayload } from "@/core/types";

export async function updateMemberProfile(data: ProfileUpdatePayload) {
  return api.patientTyped.update_profile({ data });
}
